import { useTranslation } from 'react-i18next'
import { WhatsappIcon } from '@velasca/icons/whatsapp'
import { trackEvent } from '@velasca/utils/track-event'
import { SansText } from '../SansText/SansText'
import { Button, Container } from './WhatsappBuyButton.styles'
import type { WhatsappBuyButtonProps } from './WhatsappBuyButton.types'

export const WhatsappBuyButton = ({
  productURL = '',
  productTitle = '',
  productColor = '',
  selectedSize = '',
}: WhatsappBuyButtonProps): JSX.Element => {
  const { t } = useTranslation('product')

  const WAURL = `https://wa.me/${t('whatsappNumber')}/?text=${encodeURI(
    t(
      selectedSize
        ? 'whatsappBuyButtonMessageWithSize'
        : 'whatsappBuyButtonMessage',
    )
      .replace('[[PRODUCT_URL]]', productURL)
      .replace('[[PRODUCT_SIZE]]', selectedSize),
  )}`

  const handleClick: () => void = () => {
    trackEvent({
      googleAnalytics: {
        eventName: 'whatsapp_buy_button',
        data: { title: productTitle, color: productColor },
      },
    })
  }

  return (
    <Container>
      <Button as="a" target="_blank" href={WAURL} onClick={handleClick}>
        <WhatsappIcon width={16} height={16} />
        <SansText uppercase fontWeight="500" color="primary">
          {t('whatsappBuyButtonLinkText')}
        </SansText>
      </Button>
      <SansText
        fontWeight="500"
        as="p"
        color="gray"
        size="sm"
        margin="1.5rem auto 0px"
      >
        {t('whatsappBuyButtonDescription')}
      </SansText>
    </Container>
  )
}
